import $ from 'jquery';

const $addAddressContainer = $( '.my-account__content-info--add-address' );
const $addAddressCheckBox = $( '#delivery_address' );

const $addAddressButton = $( '.confirm__add-address-button' );

$addAddressCheckBox.on( 'click', () => {
	$addAddressContainer.toggle();
} )

const $changeAddress = $( '.confirm__address' );

let newAddress = false;
let selected = false;
$changeAddress.on( 'change', ( e ) => {
	selected = $( e.currentTarget ).find( ":selected" );
	newAddress = selected.val();
} );

$addAddressButton.on( 'click', () => {
	$( '.notice' ).hide();
	let error = false;

	if ( !newAddress || !selected ) {
		$changeAddress.addClass( 'no-input__error' );
		error = true;
	}

	if ( error ) {
		return false;
	}

	$( '.hidden-inputs__name' ).val( selected.data( 'name' ) );
	$( '.hidden-inputs__street' ).val( selected.data( 'address' ) );
	$( '.hidden-inputs__postal-code' ).val( selected.data( 'postal-code' ) );
	$( '.hidden-inputs__city' ).val( selected.data( 'city' ) );
	$( '.hidden-inputs__country-code' ).val( selected.data( 'country-code' ) );

	$( '.value--name' ).text( selected.data( 'name' ) );
	$( '.value--street' ).text( selected.data( 'address' ) );
	$( '.value--postal-code' ).text( selected.data( 'postal-code' ) );
	$( '.value--city' ).text( selected.data( 'city' ) );
	$( '.value--country-code' ).text( selected.data( 'country' ) );

	$changeAddress.val( '' );

	$addAddressContainer.hide();
	$addAddressCheckBox.prop( "checked", false );
} );